import { useCallback, useMemo } from 'react'

import { ToggleSwitch, ToggleSwitchOption } from '@smartbear/swagger-portal-component-library'
import { t } from 'i18next'

import { APIRenderers, OpenAPIRendererState } from '~/shared/types/portal'

enum RendererKey {
  ELEMENTS = 'elements',
  SWAGGER_UI = 'swagger-ui',
}

export const OpenAPIRendererToggle = ({
  onToggle = () => {},
  renderer,
  isOas3_2 = false,
}: {
  onToggle?: (value: boolean) => void
  renderer?: APIRenderers | OpenAPIRendererState
  isOas3_2?: boolean
}) => {
  const options: [ToggleSwitchOption, ToggleSwitchOption] = useMemo(() => [
    { 
      path: RendererKey.ELEMENTS, 
      label: t('components.ui.apiViewer.renderer.toggle.left.label'),
      disabled: isOas3_2,
      disabledTooltip: isOas3_2 ? t('components.ui.apiViewer.renderer.toggle.elementsNotSupported') : undefined,
    },
    { 
      path: RendererKey.SWAGGER_UI, 
      label: t('components.ui.apiViewer.renderer.toggle.right.label'),
    }
  ], [isOas3_2])

  const activePath = renderer === APIRenderers.SWAGGER_UI ? RendererKey.SWAGGER_UI : RendererKey.ELEMENTS

  const handleSwitch = useCallback((option: ToggleSwitchOption) => {
    const isSwaggerUI = option.path === RendererKey.SWAGGER_UI
    onToggle(isSwaggerUI)
  }, [onToggle])

  return (
    <ToggleSwitch
      className="sp-api-viewer-renderer-toggle"
      options={options}
      activePath={activePath}
      onSwitch={handleSwitch}
      width="w-59"
      buttonClassName="sp-api-viewer-renderer-toggle-button"
    />
  )
}